<template>
  <div v-if="page">
    <div class="content_page_bg" />
    <Breadcrumbs :breaditems="breaditems" />
    <template v-if="pageType('shops')">
      <Shops :page="page" :h1="pageH1" />
    </template>
    <template v-else-if="pageType('shop')">
      <Shop :page="page" :h1="pageH1" />
    </template>
    <template v-else>
      <div v-if="pageType('about_us')" class="page_background category_bg home_bg" />
      <section class="about">
        <div class="container">
          <div class="about_wrap">
            <div class="section_top">
              <h1 v-text="pageH1" />
            </div>
            <div class="about_article" v-html="page.description" />
            <div v-if="pageType('html_sitemap')" class="about_article">
              <ul>
                <li v-for="(link, index) in htmlSitemap" :key="`${index}_html_sm`">
                  <nuxt-link :to="$formatUrl(localePath(link.slug))">
                    {{ link.title }}
                  </nuxt-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </template>

    <render-on-scroll :offset-y="100">
      <ExtWrap v-if="getExtSup" :extensions="getExtSup" />
      <ExtWrap v-if="getExtTop" :extensions="getExtTop" />
      <ExtWrap v-if="getExtMid" :extensions="getExtMid" />
      <ExtWrap v-if="getExtBot" :extensions="getExtBot" />
    </render-on-scroll>
  </div>
</template>
<script>
import Breadcrumbs from '../components/Breadcrumbs'
import Shops from '@/components/pages/Shops'
import Shop from '@/components/pages/Shop'
import ExtWrap from '@/components/modules/ExtWrap'

export default {
  components: {
    Breadcrumbs,
    Shops,
    Shop,
    ExtWrap
  },
  transition: {
    name: 'intro',
    afterLeave (el) {
      this.$nuxt.$emit('mm_hide')
    }
  },
  async asyncData ({ app, params, error, i18n }) {
    try {
      const page = await app.$axios.$get(`/api/promo/pages/${params.slug}/`)
      return {
        htmlSitemap: page.htmlSitemap,
        seo: page.seo_template,
        page: page.data
      }
    } catch (err) {
      console.error(`-.vue error: ${err}`)
      await error({ statusCode: 404, message: i18n.t('error.title_404') })
    }
  },
  data () {
    return {
      htmlSitemap: null,
      seo: null,
      page: null
    }
  },
  head () {
    if (!this.page) {
      return {}
    }
    const i18nHead = this.$formatSeoTags(
      this.$nuxtI18nHead({ addSeoAttributes: { canonicalQueries: ['page'] } }),
      this.page.indexing_status,
      this.pageCanonical
    )
    return {
      htmlAttrs: {
        ...i18nHead.htmlAttrs
      },
      title: this.pageMetaTitle,
      meta: [
        { hid: 'description', name: 'description', content: this.pageMetaDescription },
        { hid: 'keywords', name: 'keywords', content: this.pageMetaKeywords },
        { property: 'og:locale', content: this.$i18n.locale },
        { property: 'og:title', content: this.pageMetaTitle },
        { property: 'og:description', content: this.pageMetaDescription },
        { property: 'og:url', content: process.env.API_URL_BROWSER + this.$nuxt.$route.fullPath },
        { property: 'og:image', content: process.env.API_URL_BROWSER + '/icons/logo.svg' },
        { hid: 'twitter_card', property: 'twitter:card', content: 'summary' },
        { hid: 'twitter_title', property: 'twitter:title', content: this.pageMetaTitle },
        { hid: 'twitter_description', property: 'twitter:description', content: this.pageMetaDescription },
        { hid: 'twitter_image', property: 'twitter:image', content: process.env.API_URL_BROWSER + '/icons/logo.svg' },
        ...i18nHead.meta
      ],
      link: [
        ...i18nHead.link
      ]
    }
  },
  computed: {
    breaditems () {
      return [
        {
          to: 'index',
          exact: true,
          text: this.$i18n.t('breadcrumbs.home'),
          alt: this.$i18n.t('breadcrumbs.home_in_breadcrumbs')
        },
        {
          to: this.localePath({ path: this.$nuxt.$route.fullPath }),
          disable: true,
          text: this.page.title
        }
      ]
    },
    pageMetaTitle () {
      return this.page.meta_title ?? this.seo.title ?? this.page.title
    },
    pageMetaDescription () {
      return this.page.meta_description ?? this.seo.description ?? this.page.title
    },
    pageMetaKeywords () {
      // return this.page.meta_keywords ?? ''
      return ''
    },
    pageH1 () {
      return this.page.meta_h1 ?? this.seo.h1 ?? this.page.title
    },
    pageCanonical () {
      return this.page.indexing_status === 'enabled' ? (this.page.canonical ? this.page.canonical : (process.env.API_URL_BROWSER + this.$nuxt.$route.fullPath)) : null
    },
    getExtSup () {
      return this.page.supExtension ? [this.page.supExtension] : null
    },
    getExtTop () {
      return this.page.topExtension ? [this.page.topExtension] : null
    },
    getExtMid () {
      return this.page.middleExtension ? [this.page.middleExtension] : null
    },
    getExtBot () {
      return this.page.bottomExtension ? [this.page.bottomExtension] : null
    }
  },
  mounted () {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  },
  methods: {
    pageType (type) {
      return this.page.template_type === type
    }
  }
}
</script>
